var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Button',{staticClass:"pull-right push-10-l",attrs:{"size":"xs","tooltip":_vm.tooltip,"icon":_vm.icon,"color":_vm.color,"text":_vm.text},on:{"click":function($event){return _vm.$emit("click")}}})}
var staticRenderFns = []

export { render, staticRenderFns }